import { useEffect } from 'react';
import { Actions } from '../../../../../client/Actions';
import { useHouseOfferSearchParams } from '../../../house-offer/context/HouseOfferSearchParamsContext';
import { format } from 'date-fns';

export function useReservationLoader({
                                       reservationId,
                                       setCustomer,
                                       setPaymentOnBookingPercentage,
                                       setSecurityDepositAmount,
                                       setAdditionalInformation,
                                       setReservation,
                                       setPaymentSelections,
                                       setManualDiscounts,
                                       setManualAdditionalPayments,
                                       setReservationLoading
                                     }) {

  const { searchParams, setSearchParams } = useHouseOfferSearchParams();


  useEffect(() => {
    if (!reservationId) return;

    Actions.get('reservation/' + reservationId, (data) => {
      if (!searchParams?.startDate) {
        setSearchParams({
          startDate: data.startDate,
          endDate: data.endDate,
          adults: data.guests.adults,
          children: data.guests.children,
          infants: data.guests.infants
        });
      }

      setCustomer(data.customer);
      setPaymentOnBookingPercentage(data.paymentOnBookingPercentage);
      setSecurityDepositAmount(data.paymentSummary.securityDepositAmount);

      setAdditionalInformation({
        checkinTime: data.checkinTime,
        checkoutTime: data.checkoutTime,
        reservationComment: data.reservationComment
      });
      setReservation(data);
      setPaymentSelections({
        paymentModel: data.paymentSummary.paymentModel,
        paymentTypeOnBooking: data.paymentTypeOnBooking,
        paymentTypeDeposit: data.paymentTypeDeposit,
        paymentTypeOnCheckin: data.paymentTypeOnCheckin,
        paymentDueOnBooking: format(data.paymentDueOnBooking, 'yyyy-MM-dd'),
        paymentDueOnCheckin: format(data.paymentDueOnCheckin, 'yyyy-MM-dd'),
        needInvoice: data.needInvoice,
        invoiceName: data.invoiceName,
        invoiceNip: data.invoiceNip,
        invoiceAddress: data.invoiceAddress
      });
      setManualDiscounts(data.paymentSummary.discounts.filter((d) => !d.automatic));
      setManualAdditionalPayments(data.paymentSummary.additionalPayments.filter((ap) => !ap.automatic));
      setReservationLoading(false);
    });
  }, [reservationId]);
}
